import React, { useState } from 'react';
import { Box, Typography, Button, Container, Grid, useTheme, useMediaQuery } from '@mui/material';
import { Icon } from '@iconify/react';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import UserUploadCard from '../components/UserUploadCard';
import RecordUploadCard from '../components/RecordUploadCard';
import { useToast } from '../components/ui/ToastProvider';
interface BulkUploadProps {
  onLogout: () => void;
}
export default function BulkUpload({
  onLogout
}: BulkUploadProps) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [showUploadCard, setShowUploadCard] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const {
    showToast
  } = useToast();
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleDownloadSample = () => {
    console.log('Download sample Excel');
    showToast('Sample template downloaded', 'success');
  };
  const handleUploadRecords = () => {
    setShowUploadCard(true);
  };
  const handleCloseUploadCard = () => {
    setShowUploadCard(false);
  };
  return <Box sx={{
    width: '100%',
    height: '100%',
    bgcolor: 'background.default'
  }} data-id="element-3133" data-mp="ucnk3q67xw82">
      <TopBar onMenuClick={handleDrawerToggle} onLogout={onLogout} data-id="element-3134" data-mp="13foo9lbixd93" />
      <Sidebar open={mobileOpen} onClose={handleDrawerToggle} activePage="bulk-upload" data-id="element-3135" data-mp="13dbwkgfyroiu" />
      <Box component="main" sx={{
      flexGrow: 1,
      p: 3,
      width: {
        xs: '100%',
        sm: `calc(100% - ${240}px)`
      },
      ml: {
        xs: 0,
        sm: `${240}px`
      },
      mt: 8
    }} data-id="element-3136" data-mp="1d587wt729b50">
        <Container maxWidth="xl" data-id="element-3137" data-mp="3swdy2y1sd71n">
          {/* Header */}
          <Grid container spacing={2} alignItems="center" sx={{
          mb: 3
        }} data-id="element-3138" data-mp="3sww2wj2iktl6">
            <Grid item xs={12} md={6} data-id="element-3139" data-mp="1ruo61hvii52n">
              <Box sx={{
              display: 'flex',
              alignItems: 'center'
            }} data-id="element-3140" data-mp="1rvpjtu3wx5o2">
                <Icon icon="lucide:upload" width={24} height={24} color="#0EA5E9" data-id="element-3141" data-mp="21slsbztt9rsm" />
                <Typography variant="h5" component="h1" sx={{
                ml: 1.5,
                fontWeight: 600
              }} data-id="element-3142" data-mp="26p2guv4xa868">
                  Bulk Upload
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6} data-id="element-3143" data-mp="2phwvfnymvy9x">
              <Box sx={{
              display: 'flex',
              gap: 2,
              flexWrap: 'wrap',
              justifyContent: {
                xs: 'flex-start',
                md: 'flex-end'
              }
            }} data-id="element-3144" data-mp="2pgvcyyfag9i6">
                <Button variant="outlined" startIcon={<Icon icon="lucide:download" width={18} height={18} data-id="element-3146" data-mp="isuy73r2lewr" />} onClick={handleDownloadSample} sx={{
                whiteSpace: 'nowrap',
                display: {
                  xs: isMobile ? 'none' : 'inline-flex',
                  sm: 'inline-flex'
                }
              }} data-id="element-3145" data-mp="mw105z75gjxf">
                  Download Sample
                </Button>
                <Button variant="contained" startIcon={<Icon icon="lucide:upload" width={18} height={18} data-id="element-3148" data-mp="rucasc59qygp" />} onClick={handleUploadRecords} data-id="element-3147" data-mp="wt5qmb8131k1">
                  Upload Records
                </Button>
              </Box>
            </Grid>
          </Grid>
          {/* Upload Card */}
          {showUploadCard && <RecordUploadCard onClose={handleCloseUploadCard} data-id="element-3149" data-mp="150qltngr6j54" />}
        </Container>
      </Box>
    </Box>;
}